/* eslint-disable react/prop-types */
import { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCoursesAsync } from 'store/actions';

const NavigationRoute = createContext();
export const useNavigationRoutes = () => {
  return useContext(NavigationRoute);
};

export const SideBarNavigationProvider = ({ children }) => {
  const [courses, setCourseRoute] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    let mounted = true;
    dispatch(fetchCoursesAsync())
      .unwrap()
      .then(res => {
        if (mounted) {
          setCourseRoute(res);
        }
      })
      .catch(e => console.log(e.message));

    setLoading(false);
    return () => {
      mounted = false;
    };
  }, []);

  const value = {
    routes: [
      {
        name: 'Dashboard',
        link: '/dashboard'
      },
      {
        name: 'Courses',
        items: courses,
        link: '/courses'
      },
      {
        name: 'Grades',
        link: '/grades'
      },
      {
        name: 'Reports',
        link: '/reports'
      }
    ]
  };

  return <NavigationRoute.Provider value={value}>{!loading && children}</NavigationRoute.Provider>;
};

export const adminRoutes = [
  {
    name: 'Side Admin',
    items: [
      {
        name: 'Admin 1'
      },
      {
        name: 'Admin 2'
      },
      {
        name: 'Other admins',
        items: [
          {
            name: 'Admin 3',
            items: [
              {
                name: 'Admin 4'
              },
              {
                name: 'Admin 7'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'Activities',
    items: [
      {
        name: 'Activity 1'
      },
      {
        name: 'Activity 2'
      }
    ]
  }
];
